import * as React from 'react'

export const ListIcon = React.memo(
  ({ className, ...props }: React.SVGProps<SVGSVGElement>) => {
    return (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
<g clip-path="url(#clip0_6001_108000)">
<path d="M2.39062 5C2.39062 5.55228 1.9429 6 1.39062 6C0.838345 6 0.390625 5.55228 0.390625 5C0.390625 4.44772 0.838345 4 1.39062 4C1.9429 4 2.39062 4.44772 2.39062 5Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.39062 5C5.39062 4.58579 5.72642 4.25 6.14062 4.25H18.1406C18.5548 4.25 18.8906 4.58579 18.8906 5C18.8906 5.41421 18.5548 5.75 18.1406 5.75H6.14062C5.72642 5.75 5.39062 5.41421 5.39062 5Z" fill="currentColor"/>
<path d="M2.39062 10C2.39062 10.5523 1.9429 11 1.39062 11C0.838345 11 0.390625 10.5523 0.390625 10C0.390625 9.4477 0.838345 9 1.39062 9C1.9429 9 2.39062 9.4477 2.39062 10Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.39062 10C5.39062 9.5858 5.72642 9.25 6.14062 9.25H18.1406C18.5548 9.25 18.8906 9.5858 18.8906 10C18.8906 10.4142 18.5548 10.75 18.1406 10.75H6.14062C5.72642 10.75 5.39062 10.4142 5.39062 10Z" fill="currentColor"/>
<path d="M2.39062 15C2.39062 15.5523 1.9429 16 1.39062 16C0.838345 16 0.390625 15.5523 0.390625 15C0.390625 14.4477 0.838345 14 1.39062 14C1.9429 14 2.39062 14.4477 2.39062 15Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.39062 15C5.39062 14.5858 5.72642 14.25 6.14062 14.25H18.1406C18.5548 14.25 18.8906 14.5858 18.8906 15C18.8906 15.4142 18.5548 15.75 18.1406 15.75H6.14062C5.72642 15.75 5.39062 15.4142 5.39062 15Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_6001_108000">
<rect width="18.5" height="12" fill="white" transform="translate(0.390625 4)"/>
</clipPath>
</defs>
</svg>

    )
  },
)

ListIcon.displayName = 'ListIcon'
